<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'}]"
        v-if="isLoaded">
        <div id="aia_header">
            <div class="aia-header">
                <div class="aia-logo">
                    <img id="mass_logo"
                        class="img-fluid"
                        v-if="theme == 'mass'"
                        src="@/assets/logo/mass/logo-aia.png" />
                    <img id="prestige_logo"
                        class="img-fluid"
                        v-if="theme == 'prestige'"
                        src="@/assets/logo/prestige/logo-prestige.png" />
                </div>
            </div>
        </div>
        <div id="gift_content_wrapper">
            <div id="gift_content"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="gift-body-wrapper">
                    <div class="serial-modal__content">
                        <div class="serial-modal__header">
                            <GiftHeader
                                :campaign="campaign"
                                :theme="theme" />
                        </div>
                        <div class="serial-modal__body">
                            <GiftSerial
                                :lbl="lbl"
                                :campaign="campaign"
                                :theme="theme"
                                :busGift="busGift"
                                :modalController="modalController" />
                            <GiftRedeemDate
                                id="redeem_on_date"
                                :lbl="lbl.gift_serial.redeem_on"
                                :isUtc="true"
                                :isShowTime="true"
                                :campaign="campaign" />
                            <GiftTimer
                                :lbl="lbl"
                                :campaign="campaign"
                                :theme="theme"
                                :busGift="busGift" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div id="gift_logo">
            <img src="@/assets/bzbslogo/buzzebees-logo-dark@3x.png" />
        </div> -->

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
import Vue from 'vue';
//mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ThemeHelper from "@/helper/ThemeHelper.js";
//model
import { SerialGiftDataModel } from "../model/SerialGiftDataModel.js";
//service
import GiftService from "../service/GiftService.js";
//component
import GiftHeader from "../component/GiftSerialHeader.vue";
import GiftRedeemDate from "../component/GiftRedeemDate.vue";
import GiftSerial from "../component/GiftSerial.vue";
import GiftTimer from "../component/GiftTimer.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
export default {
    name: 'Gift',
    mixins: [ErrorApiMixin, LocaleMixin],
    components: {
        GiftHeader,
        GiftRedeemDate,
        GiftSerial,
        GiftTimer,
        ModalMaster
    },
    data: function () {
        return {
            //page
            isLoaded: false,
            theme: '',
            campaign: new SerialGiftDataModel(),
            //bus
            busGift: new Vue(),
            //modal
            modalController: null,
            alertModal: null
        };
    },
    created: function () {
        this.initialModal();
        //94171_195
        if (this.$route.query.rk)
            this.initialSerial(this.$route.query.rk);
    },
    methods: {
        initialSerial: function (redeemKey) {
            GiftService.apiGiftInfo(redeemKey)
                .then(res => {
                    console.log('res', res);
                    // this.initialTheme(res.data.user_tier || res.data.UserTier);
                    // this.campaign.setDataFromAPI(res.data);

                    // new shape response
                    var responseBody = (res && res.data) ? res.data : res || {};
                    var payload = responseBody.Data || responseBody.data || responseBody;
                    var userTier = payload.user_tier || payload.userTier || payload.UserTier || null;
                    
                    this.initialTheme(userTier);
                    this.campaign.setDataFromAPI(payload);

                    this.$nextTick(() => {
                        this.isLoaded = true;
                    });
                }).catch(err => {
                    console.log(err);
                });
        },
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
            this.copySuccessToast = modalFactory.getCopySuccessToast();
        },
        initialTheme: function (userTier) {
            // use helper function to get theme
            var themeInfo = ThemeHelper.getThemeFromTier(userTier);
            this.theme = themeInfo.theme;
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "../../../components/Layout/header/AIAHeader.scss";

.aia-header {
    height: 60px;
    #mass_logo {
        width: 50px;
    }
    #prestige_logo {
        width: 100px;
        height: 40px;
    }
}

.page-mass {
    .aia-header {
        background-color: $mass_theme_color;
    }
}

.page-prestige {
    .aia-header {
        background-color: $prestige_theme_color;
    }
}

#gift_content_wrapper {
    padding: {
        left: 15px;
        right: 15px;
    };
    padding-top: calc(60px + 16px);

    #gift_content {
        // padding: {
        //     bottom: 50px;
        // }
        border-radius: 10px;
        // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);

        .gift-body-wrapper {
            // padding: 24px;
        }

        .serial-modal__header {
            margin-bottom: 24px;
        }

        // #redeem_on_date {
        //     font-size: 1.45rem;
        //     // font-family: $heading;
        //     // line-height: 1;
        //     text-align: center;
        // }

        &.mass {
            background-color: #ffffff;

            #redeem_on_date {
                color: $mass_detail_font_color;
            }
        }

        // &.prestige {
        //     // background-color: #fffdf8;

        //     #redeem_on_date {
        //         color: $prestige_detail_font_color;
        //     }
        // }
    }
}

#gift_logo {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20px;
    height: 25px;

    @media (max-width: $max-width-mini-mobile) {
        height: 20px;
    }

    img {
        display: block;
        width: auto;
        max-height: 100%;
        margin: {
            left: auto;
            right: auto;
        };
    }
}
</style>
